module.exports = __webpack_public_path__ + "fonts/ttnorms-light-webfont.58113696.woff";